import script from "./HomepageSidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./HomepageSidebar.vue?vue&type=script&setup=true&lang=js"

import "./HomepageSidebar.vue?vue&type=style&index=0&id=4888ed14&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4888ed14"]])

export default __exports__